<div
  #tray
  class="timeline-tray"
  [class.is-drop-target]="dropActive()"
  [class.is-receptive]="drag.current()?.source === dragSource.bar"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event, tray)"
  (drop)="onDrop($event)"
>
  <div class="timeline-tray-header">
    <span>{{ header() }}</span>
    <span class="timeline-tray-count">{{ items().length }}</span>
  </div>

  @if (drag.current()?.source === dragSource.bar) {
    <div class="timeline-tray-drop-hint"><i class="fa fa-inbox" aria-hidden="true"></i> {{ dropHint() }}</div>
  }

  <div class="timeline-tray-list">
    @for (item of items(); track item.id) {
      <div
        class="timeline-tray-item"
        [class]="toneClass(item)"
        draggable="true"
        [attr.title]="item.sublabel"
        (dragstart)="onDragStart($event, item)"
        (dragend)="onDragEnd()"
        (click)="itemClicked.emit(item)"
      >
        <div class="timeline-tray-item-top">
          <span class="timeline-tray-item-label">{{ item.label }}</span>
          @if (item.meta) {
            <span class="timeline-tray-item-meta">{{ item.meta }}</span>
          }
        </div>
        @if (item.sublabel) {
          <div class="timeline-tray-item-sublabel">{{ item.sublabel }}</div>
        }
        @if (item.note) {
          <div class="timeline-tray-item-note">{{ item.note }}</div>
        }
      </div>
    } @empty {
      <div class="timeline-tray-empty">{{ emptyText() }}</div>
    }
  </div>
</div>
